import {Grid} from "@leap4/frontend";
import {Route, Switch} from "react-router-dom";
import {urlService} from "../../routing/urlsService";
import React from "react";
import GroupsPage from "./Groups/GroupsDashboardModule"
import {AddGroup} from "./Group/create/AddGroup";
import {EditGroup} from "./Group/edit/EditGroup";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../shared/OneOrgOnly/OneOrgOnly";

function GroupsModule() {
    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }
    return (
        <Grid direction="row" alignItems="center" container>
            <Switch>
                {/* WARNNING: Never warp <Route/> with another component (even Grid)*/}
                <Route exact path={urlService.groups()} component={GroupsPage}/>
                <Route exact path={urlService.createGroup()} component={AddGroup}/>
                <Route exact path={urlService.editGroup()} component={EditGroup}/>

            </Switch>
        </Grid>
    )
}


export default GroupsModule